import React, {useState, useEffect, useRef, Suspense} from 'react';
import Navigation from "./Navigation";
import Header from "./Header";
import Button from "./component-assets/Button";
import {
    actionAppearance,
    bulkDeleteModal, checkAll,
    formCheck, formFail, formSuccess, getCountryOptions, handleSubmitActions,
    iAmHigherAuthority, isBannerPresent,
    paginateData, searchFunc,
    showModal,
    sortFunc
} from "../libs";
import CampusDropDown from "./component-assets/CampusDropDown";
import {ReactSession} from "react-client-session";
import {AES, enc} from "crypto-js";
import ApiRequester from "./ApiRequester";
import TableBody from "./component-assets/TableBody";
import TableHeaders from "./component-assets/TableHeaders";
import {toast, ToastContainer} from "react-toastify";
import BulkDeleteModal from "./component-assets/BulkDeleteModal";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton";

const StringBuilder = (props) => {
    let dData, bData, headerData;

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    headerData = [
        {label: "Output Type", key: "output", align: "center"},
        {label: "Template Format", key: "text_format", align: "left"}
    ];

    const templateItems = [
        {label: "Device Name", key: "device_name"},
        {label: "Device Description", key: "device_description"},
        {label: "Serial Number", key: "manufacture_uuid"},
        {label: "Resident First Name", key: "resident_first_name"},
        {label: "Resident Last Name", key: "resident_last_name"},
        {label: "Resident Name", key: "resident_name"},
        {label: "Area Name", key: "area_name"},
        {label: "Near Area", key: "near_area_name"},
        {label: "Event Category", key: "event_category"},
        {label: "Event Type", key: "event_type"},
        {label: "Event Stage", key: "stage"},
        {label: "Custom Text", key: "custom"}
    ]
    const exampleEvent = {
        "campus_id":0,
        "event_id":"2990900132@IN17542916192821",
        "area_group_name":"AllPage",
        "area_name":"Mountain Spring 301",
        "device_description":"Bathroom",
        "device_name":"AIO Station",
        "event_category":"Emergency",
        "event_type":"Pull Cord Pulled",
        "manufacture_name":"Inovonics",
        "manufacture_uuid":"4555684",
        "near_area_name":"West Cafe",
        "resident_first_name":"Daniel",
        "resident_id":0,
        "resident_last_name":"Avis",
        "resident_name":"Daniel Avis",
        "stage":"CREATE",
     }
    const outputData = [
        {output_type_id: 0, output_name: "Global Default", active: true},
        {output_type_id: 3, output_name: "Mobile", active: dData?.campusData[dData?.acnt.toString()]?.app_active},
        {output_type_id: 4, output_name: "Text", active: dData?.campusData[dData?.acnt.toString()]?.text_messaging_active},
        {output_type_id: 5, output_name: "Voice", active: dData?.campusData[dData?.acnt.toString()]?.voice_active},
        {output_type_id: 6, output_name: "Email", active: dData?.campusData[dData?.acnt.toString()]?.email_active},
        {output_type_id: 7, output_name: "Pager", active: dData?.campusData[dData?.acnt.toString()]?.pager_active}
    ];

    // Main Page Control Variables
    const [addRights, setAddRights] = useState(iAmHigherAuthority(80, dData.role_weight));
    const [deleteRights, setDeleteRights] = useState(iAmHigherAuthority(80, dData.role_weight));
    const [editRights, setEditRights] = useState(iAmHigherAuthority(80, dData?.role_weight));
    const [read, setRead] = useState(true);
    const [originLoaded, setOriginLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />);
    // Main Data Control Variables
    const [dataOrigin, setDataOrigin] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [tempIdList, setTempIdList] = useState([]);
    const [count, setCount] = useState(0);
    const [op, setOp] = useState(null);
    // Main Table Control Variables
    const [storePage, setStorePage] = useState(1);
    const [tableRows, setTableRows] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [storedIndex, setStoredIndex] = useState(0);
    const [search, setSearch] = useState("");
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [sorter, setSorter] = useState({
        sortColumn: "area_name",
        sortOrder: "asc"
    });
    // Main Edit Consortium
    const [strRep, setStrRep] = useState("");
    const [selectBucket, setSelectBucket] = useState([]);
    const [optionBucket, setOptionBucket] = useState([]);
    const [outputOptions, setOutputOptions] = useState([]);
    const [customValues, setCustomValues] = useState({});

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, "read-only": read,
                                procedure: "getalerttemplates", reqType: "stored"}).then(data => {
                setDataOrigin(data);
                setOriginLoaded(true);
            });
            setRead(true);
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    // ******************
    // MONITORED ACTIONS
    // ******************
    useEffect(() => {
        let tmpData, pRules, searchKeys;

        searchKeys = ["output", "text_format"];
        tmpData = searchFunc(search, dataOrigin, searchKeys);

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setActiveData(tmpData);
    }, [search, dataOrigin]);

    useEffect(() => {
        let pRules = paginateData(activeData, page, perPage);
        setPRules(pRules);
        if (activeData.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={deleteRights}
                                writeAccess={editRights} unk={"t-"}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBtn"])}
                                tableHeaders={headerData} editModal={editModal} modal={editRights} parentComponent={"Settings"}
                                dData={dData} checkboxlist={tempIdList} modal_name={"Edit"}
                                setCheckboxId={(value) => {setTempIdList(value)}} checkidkey={"template_id"} />);
    }, [activeData, sorter, page, perPage, tempIdList]);

    // Generate string representation
    useEffect(() => {
        let tmp = "";
        for (let i = 0; i < selectBucket.length; i++) {
            let itemVal = "";
            if (selectBucket[i].key === 'custom') {
                itemVal = customValues[selectBucket[i].customId] || "";
            } else if (selectBucket[i].key.includes(".")) {
                itemVal = exampleEvent[selectBucket[i].key.split(".")[1]] || "";
            } else {
                itemVal = exampleEvent[selectBucket[i].key] || "";
            }
            tmp += `${itemVal} `;
        }
        tmp = tmp.trim();
        setStrRep(tmp);
        textBuilderValidate()
    }, [selectBucket, customValues, op]);

    useEffect(() => {
        if (![originLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [originLoaded]);

    function editModal(editIndex){
        let dataIndex, tempArray;
        if (editRights){
            dataIndex = parseInt(editIndex);
            setStoredIndex(dataIndex);
            tempArray = activeData[dataIndex].text_format.split(",");
            setOp("Edit");
            document.getElementById("uCheckHead").checked = true;
            document.getElementById("uCheckHead").click();
            document.getElementById("string-table").classList.add("d-none");
            document.getElementById("string-builder").classList.remove("d-none");
            document.getElementById("ot-id-div").classList.add("d-none");
            // Load the template into the drop zone
            loadTemplateFromArray(tempArray);
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    // New function to load template from array - takes tempArray and populates drop zone
    const loadTemplateFromArray = (tempArray) => {
        if (!Array.isArray(tempArray)) {
            console.error('tempArray must be an array of strings');
            return;
        }

        // Clear current drop zone
        setSelectBucket([]);
        setCustomValues({});

        // Process each string in tempArray to find matching fields
        const newSelectBucket = [];
        const newCustomValues = {};

        tempArray.forEach((tempString, index) => {
            // Try to find a matching field by key
            let foundField = null;

            // First, try exact key matches
            foundField = templateItems.find(item => item.key === tempString);

            // If no exact match, try to find by partial key matches
            if (!foundField) {
                foundField = templateItems.find(item =>
                    tempString.toLowerCase().includes(item.key.toLowerCase()) ||
                    item.key.toLowerCase().includes(tempString.toLowerCase())
                );
            }

            if (foundField) {
                if (foundField.key === 'custom') {
                    // For custom items, add a unique identifier
                    const customId = `custom_${Date.now()}_${index}_${Math.random().toString(36).substr(2, 9)}`;
                    newSelectBucket.push({ ...foundField, customId });

                    // Handle custom.in format - extract the part after the dot
                    if (tempString.includes('.')) {
                        const customValue = tempString.split('.')[1] || tempString;
                        newCustomValues[customId] = customValue;
                    } else {
                        newCustomValues[customId] = tempString;
                    }
                } else {
                    newSelectBucket.push(foundField);
                }
            } else {
                // If no matching field found, treat as custom text
                const customId = `custom_${Date.now()}_${index}_${Math.random().toString(36).substr(2, 9)}`;
                newSelectBucket.push({
                    label: "Custom Text",
                    key: "custom",
                    customId
                });

                // Handle custom.in format - extract the part after the dot
                if (tempString.includes('.')) {
                    const customValue = tempString.split('.')[1] || tempString;
                    newCustomValues[customId] = customValue;
                } else {
                    newCustomValues[customId] = tempString;
                }
            }
        });

        // Update state
        setSelectBucket(newSelectBucket);
        setCustomValues(newCustomValues);
    };

    // ********************
    // FUNCTION EXPRESSIONS
    // ********************
    // Handle drag start
    const handleDragStart = (e, item) => {
        // Check if item is already in drop zone (except custom)
        if (item.key !== 'custom' && selectBucket.some(bucketItem => bucketItem.key === item.key)) {
            e.preventDefault();
            return;
        }
        e.dataTransfer.setData('application/json', JSON.stringify(item));
    };

    // Handle drop
    const handleDrop = (e) => {
        e.preventDefault();
        const item = JSON.parse(e.dataTransfer.getData('application/json'));

        if (item.key === 'custom') {
            // For custom items, add a unique identifier
            const customId = `custom_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            setSelectBucket(prev => [...prev, { ...item, customId }]);
            setCustomValues(prev => ({ ...prev, [customId]: '' }));
        } else {
            // For non-custom items, check if already exists (except custom)
            const exists = selectBucket.some(bucketItem => bucketItem.key === item.key);
            if (!exists) {
                setSelectBucket(prev => [...prev, item]);
            }
        }
    };

    // Handle drag over
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    // Remove item from selectBucket
    const removeItem = (index) => {
        const item = selectBucket[index];
        if (item.customId) {
            setCustomValues(prev => {
                const newValues = { ...prev };
                delete newValues[item.customId];
                return newValues;
            });
        }
        setSelectBucket(prev => prev.filter((_, i) => i !== index));
    };

    // Update custom value
    const updateCustomValue = (customId, value) => {
        setCustomValues(prev => ({ ...prev, [customId]: value }));
    };

    // Check if item is disabled (already in drop zone)
    const isItemDisabled = (item) => {
        if (item.key === 'custom') return false; // Custom can always be added
        return selectBucket.some(bucketItem => bucketItem.key === item.key);
    };

    // Get the actual value that would appear for a field
    const getFieldValue = (item) => {
        if (item.key === 'custom') {
            return "Enter custom text...";
        } else if (item.key.includes(".")) {
            return exampleEvent[item.key.split(".")[1]] || "No value";
        } else {
            return exampleEvent[item.key] || "No value";
        }
    };

    const textBuilderValidate = () => {
        if (op === "Add"){
            const outputTypeSelected = document.getElementById("ot-id")?.value !== null && document.getElementById("ot-id")?.value !== "";
            const hasItemsInDropZone = selectBucket.length > 0;
            return outputTypeSelected && hasItemsInDropZone;
        }else if (op === "Edit"){
            return selectBucket.length > 0;
        }else{
            return false;
        }
    }

    const hasOutputId = (id) => {
        for (let i=0; i < dataOrigin.length; i++){
            if (dataOrigin[i].output_type_id === id){
                return true;
            }
        }
        return false;
    }

    // **************
    // PAGE FUNCTIONS
    // **************

    function performAddSubmit(){
        let payload, outType, format;
        if (addRights){
            handleSubmitActions("addEditSubmit", "loadSubmit");
            outType = document.getElementById("ot-id").value;
            format = selectBucket.map((item) => {
                if (item.key === 'custom') {
                    // For custom items, include the custom text value
                    return `custom.${customValues[item.customId] || ''}`;
                } else {
                    // For regular items, just return the key
                    return item.key;
                }
            });
            payload = [{output_type_id: parseInt(outType), campus_id: campusId, text_format: format.join(","),
                        modified_by: dData.user}];
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_event_text_template", Payload: payload, urlType: "PUT", User: dData.user,
                                PKey: "template_id", Condition: "primary", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setRead(false);
                    setTempIdList([]);
                    formSuccess(`Template has been added.`, "addEditSubmit", "loadSubmit", "cancelAddEditBtn");
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addEditSubmit", "loadSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function performEditSubmit(){
        let payload, oldPayload, format;
        if (editRights){
            handleSubmitActions("addEditSubmit", "loadSubmit");
            format = selectBucket.map((item) => {
                if (item.key === 'custom') {
                    // For custom items, include the custom text value
                    return `custom.${customValues[item.customId] || ''}`;
                } else {
                    // For regular items, just return the key
                    return item.key;
                }
            });
            payload = [{template_id: activeData[storedIndex].template_id, campus_id: campusId, text_format: format.join(",")}];
            oldPayload = [{template_id: activeData[storedIndex].template_id, campus_id: campusId, text_format: activeData[storedIndex].text_format}]
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_event_text_template", Payload: payload, OldPayload: oldPayload,
                                urlType: "POST", User: dData.user, PKey: "template_id", Condition: "primary",
                                CampusId: campusId, ClientId: dData.sessionId}).then(data => {
                if (data[0] === true){
                    setRead(false);
                    setTempIdList([]);
                    formSuccess(`Template updated`, "addEditSubmit", "loadSubmit", "cancelAddEditBtn");
                    setCount(0);
                }
                else{
                    formFail(`Error during add, error code: ${data[1]}`, "addEditSubmit", "loadSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function deletePerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (deleteRights){
            payload = [];
            handleSubmitActions(submitBtn, loadBtn);
            for (let i=0; i < dContent.length; i++){
                payload.push({template_id: dContent[i][0]});
            }
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_event_text_template", Payload: payload, urlType: "DELETE",
                                PKey: "template_id", User: dData.user, Condition: "primary", CampusId: dData.acnt}).then(data => {
                if (data[0]){
                    setRead(false);
                    formSuccess("Template removed.", submitBtn, loadBtn, closeId);
                    setCount(0);
                    setTempIdList([]);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["deleteBtn"]);
                }
                else{
                    formFail(`Error performing move out, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    // ***************
    // PAGE CONSTANTS
    // ***************
    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                {deleteRights && op === null
                    ?   <Button text={"Delete"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                 id={"deleteBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                 onClick={() => bulkDeleteModal(ppRules.start, ppRules.end, activeData,
                                     "output", ["template_id", ""], "", setDContent)} />
                    :   <></>
                }
                <div className={`form-outline ${op === null ? "d-inline-flex" : "d-none"} align-bottom ms-2`}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"}
                            style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                </div>
                {addRights && op === null
                    ?   <Button text={"New Template"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                 icon={true} iconClass={"fe fe-plus me-2"}
                                 onClick={() => {
                                     setOp("Add");
                                     document.getElementById("uCheckHead").checked = true;
                                     document.getElementById("uCheckHead").click();
                                     document.getElementById("string-table").classList.add("d-none");
                                     document.getElementById("string-builder").classList.remove("d-none");
                                     document.getElementById("ot-id-div").classList.remove("d-none");
                                     document.getElementById("ot-id").value = null;
                                     loadTemplateFromArray([])
                                 }} />
                    :   <></>
                }
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)}
                            pageAction={() => {
                                setOriginLoaded(false);
                                setPageLoaded(false);
                            }}/>
        </div>
    );

    const tableHeaders = <TableHeaders checkbox={deleteRights} headerData={headerData} checkAll={() => checkAll(ppRules.start, ppRules.end, tempIdList, setTempIdList)}
                                       writeAccess={editRights} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead"} originData={dataOrigin} headerFiltersOn={false}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} modal={editRights} checkboxlist={tempIdList}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteBtn"])} modal_name={"Edit"}
                                       setPage={setPage} />

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Custom Event Text"} Title={"Templates"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <div id={"string-table"}>
                        {!pageLoaded
                            ?   skeleton
                            :   <table className={"table table-sm table-white table-hover"}>
                                    <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                        {tableHeaders}
                                    </thead>
                                    <tbody id={"tBody"}>
                                        {tableRows}
                                    </tbody>
                                </table>
                        }
                    </div>
                    <div className={"bg-white px-4 py-2 d-none"} id={"string-builder"}>
                        <div className="row">
                            <div className="col-md-8">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-around">
                                        <div>
                                            <h5 className="mb-0">Template Builder</h5>
                                        </div>
                                        <div>
                                            <button id={"cancelAddEditBtn"} className={"btn btn-outline-secondary me-3"}
                                                    onClick={() => {
                                                        setOp(null);
                                                        document.getElementById("string-table").classList.remove("d-none");
                                                        document.getElementById("string-builder").classList.add("d-none");
                                                    }}>
                                                Cancel
                                            </button>
                                            <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                                    spinner={true} text={"Loading"} id={"loadSubmit"}/>
                                            <Button id={"addEditSubmit"} text={"Save"}
                                                    class={`btn ${textBuilderValidate() ? "btn-primary" : "btn-danger"}`}
                                                    disabled={!textBuilderValidate()}
                                                    onClick={() => {
                                                        if (op === "Edit"){
                                                            performEditSubmit();
                                                        }else{
                                                            performAddSubmit();
                                                        }
                                                    }}/>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <form className={"was-validated"}>
                                            <div className={"form-floating mb-3"} id={"ot-id-div"}>
                                                <select className={"form-select"} id={"ot-id"}
                                                        required={op === "Add"}
                                                        onChange={() => {
                                                            textBuilderValidate();
                                                        }}>
                                                    <option value={null} disabled={true}></option>
                                                    {outputData.map((o, index) => {
                                                        const hasOutput = hasOutputId(o.output_type_id);
                                                        return o.active && !hasOutput ? <option value={o.output_type_id}>{o.output_name}</option> : <></>
                                                    })}
                                                </select>
                                                <label htmlFor={"ot-id"}>Output Type</label>
                                            </div>
                                        </form>
                                        <div className="mb-3">
                                            <label className="form-label">Drop Zone</label>
                                            <div
                                                className="border border-2 border-dashed p-4 text-center min-h-200"
                                                style={{
                                                    minHeight: '200px',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '8px'
                                                }}
                                                onDrop={handleDrop}
                                                onDragOver={handleDragOver}
                                            >
                                                {selectBucket.length === 0 ? (
                                                    <div className="text-muted">
                                                        <i className="fe fe-upload fs-1"></i>
                                                        <p className="mt-2">Drag items here to build your template</p>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {selectBucket.map((item, index) => (
                                                            <div
                                                                key={index}
                                                                className="badge bg-primary d-flex align-items-center gap-2"
                                                                style={{ fontSize: '14px', padding: '8px 12px' }}
                                                            >
                                                                {item.key === 'custom' ? (
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm"
                                                                        style={{
                                                                            width: '120px',
                                                                            fontSize: '12px',
                                                                            border: 'none',
                                                                            backgroundColor: 'transparent',
                                                                            color: 'white'
                                                                        }}
                                                                        placeholder="Enter text..."
                                                                        value={customValues[item.customId] || ''}
                                                                        onChange={(e) => updateCustomValue(item.customId, e.target.value)}
                                                                        onFocus={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}
                                                                        onBlur={(e) => e.target.style.backgroundColor = 'transparent'}
                                                                    />
                                                                ) : (
                                                                    item.label
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    className="btn-close btn-close-white"
                                                                    style={{ fontSize: '8px' }}
                                                                    onClick={() => removeItem(index)}
                                                                ></button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Alert Text Preview</label>
                                            <div className="form-control" style={{ minHeight: '60px', backgroundColor: '#f8f9fa' }}>
                                                {strRep || <span className="text-muted">No template items selected</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="mb-0">Available Fields</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex flex-column gap-2">
                                            {templateItems.map((item, index) => {
                                                const disabled = isItemDisabled(item);
                                                const fieldValue = getFieldValue(item);
                                                return (
                                                    <div
                                                        key={index}
                                                        className={`border rounded p-2 ${disabled ? 'cursor-not-allowed' : 'cursor-grab'}`}
                                                        draggable={!disabled}
                                                        style={{
                                                            cursor: disabled ? 'not-allowed' : 'grab',
                                                            backgroundColor: disabled ? '#f8f9fa' : '#ffffff',
                                                            transition: 'all 0.2s ease',
                                                            transform: 'translateY(0)',
                                                            boxShadow: 'none',
                                                            opacity: disabled ? 0.6 : 1,
                                                            borderColor: disabled ? '#dee2e6' : '#dee2e6'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (!disabled) {
                                                                const target = e.currentTarget;
                                                                target.style.transform = 'translateY(-2px)';
                                                                target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            const target = e.currentTarget;
                                                            target.style.transform = 'translateY(0)';
                                                            target.style.boxShadow = 'none';
                                                        }}
                                                        onDragStart={(e) => {
                                                            if (disabled) {
                                                                e.preventDefault();
                                                                return;
                                                            }
                                                            // Reset hover effects when dragging starts
                                                            const target = e.currentTarget;
                                                            target.style.transform = 'translateY(0)';
                                                            target.style.boxShadow = 'none';
                                                            handleDragStart(e, item);
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center gap-2">
                                                            <i className={`fe fe-grip-vertical ${disabled ? 'text-muted' : 'text-muted'}`}></i>
                                                            <div>
                                                                <div className={`${disabled ? 'text-muted' : 'fw-bold'}`} style={{ fontSize: '14px' }}>
                                                                    {item.label}
                                                                    {disabled && <span className="ms-2 text-muted">(Added)</span>}
                                                                </div>
                                                                <small className="text-muted">{fieldValue}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BulkDeleteModal
                deletePerform={() => deletePerform("bulkDeleteSubmit", "loadBulkDeleteSubmit", "bulkConfirmClose", ppRules.start, ppRules.end)}
                start={ppRules.start} end={ppRules.end} header={"Delete Templates"}/>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            {/* Floating Help Button - Quarter Circle Corner Shape */}
            <button 
                type={"button"} 
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Custom Event Text Templates Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The Custom Event Text Templates page allows you to create and manage custom text templates for different output types (Mobile, Text, Email, Voice, Pager). 
                                    These templates define how alert notifications are formatted when sent to users.
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-search me-2 text-primary"}></i>Searching and Managing Templates
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Use the <strong>search bar</strong> to find templates by output type or template format.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the edit icon on any template row to modify it.
                                    </li>
                                    <li className={"mb-2"}>
                                        Select multiple templates using checkboxes and click <strong>"Delete"</strong> to remove them.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-plus me-2 text-primary"}></i>Creating New Templates
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click <strong>"New Template"</strong> to create a new template.
                                    </li>
                                    <li className={"mb-2"}>
                                        Select an <strong>Output Type</strong> (Mobile, Text, Email, Voice, or Pager).
                                    </li>
                                    <li className={"mb-2"}>
                                        Only output types that are active for your campus and don't already have a template will appear in the dropdown.
                                    </li>
                                    <li className={"mb-2"}>
                                        Drag and drop fields from the "Available Fields" panel into the "Drop Zone" to build your template.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-layers me-2 text-primary"}></i>Available Fields
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Device Name:</strong> The name of the device that triggered the alert.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Device Description:</strong> Description of the device.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Serial Number:</strong> The device's serial number.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Resident First/Last Name:</strong> Individual name fields.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Resident Name:</strong> Full resident name.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Area Name:</strong> The area where the alert occurred.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Near Area:</strong> Nearby area information.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Event Category/Type:</strong> The category and type of event.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Event Stage:</strong> The current stage of the event (CREATE, etc.).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Custom Text:</strong> Add your own custom text that will appear in notifications.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-move me-2 text-primary"}></i>Building Templates
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Drag and Drop:</strong> Drag fields from "Available Fields" into the "Drop Zone" to add them to your template.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Field Order:</strong> Fields appear in the order you add them, left to right.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Custom Text:</strong> Click on a custom text field in the drop zone to enter your text.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Removing Fields:</strong> Click the X button on any field badge to remove it from the template.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Duplicate Prevention:</strong> Most fields can only be added once (except Custom Text).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Preview:</strong> The "Alert Text Preview" shows how your template will appear with example data.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-edit me-2 text-primary"}></i>Editing Templates
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the edit icon on any template row to modify it.
                                    </li>
                                    <li className={"mb-2"}>
                                        The template builder will open with the current template loaded.
                                    </li>
                                    <li className={"mb-2"}>
                                        Make your changes and click <strong>"Save"</strong> to update the template.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use <strong>"Cancel"</strong> to discard changes and return to the table view.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-trash-2 me-2 text-primary"}></i>Deleting Templates
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Select one or more templates using the checkboxes.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Delete"</strong> to remove the selected templates.
                                    </li>
                                    <li className={"mb-2"}>
                                        This action cannot be undone, so be certain before confirming deletion.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Each output type can have only one template. If a template exists, it won't appear in the "New Template" dropdown.
                                    </li>
                                    <li className={"mb-2"}>
                                        The preview shows example values to help you visualize how the final notification will look.
                                    </li>
                                    <li className={"mb-2"}>
                                        Fields are separated by spaces in the final output.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use Custom Text fields to add static text like labels or separators between dynamic fields.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StringBuilder;